export default "__VITE_ASSET__BWuhI7OK__"